import language from './languageReducer';

const allReducers = {
  language,
};

export default allReducers;
